/* eslint-disable react/jsx-props-no-spreading */
import { Box, Divider, Typography, useTheme } from "@mui/material"
import { ReactElement } from "react"
import Dropzone, { FileRejection } from "react-dropzone"

import { useScreenSize } from "../../hooks/useScreenSize"
import AppButton from "../buttons/appButton"
import { AttachmentIcon } from "../icons/icons"

interface AppDropzoneProps {
    onDrop: (acceptedFiles: File[], rejectedFiles: FileRejection[]) => void
    minFileSize: number
    maxFileSize: number
    maxFilesPerDrop: number
    disabled?: boolean
}

/** Wrapper for react-dropzone Dropzone. Applies styling and disabled functionality */
const AppDropzone = ({
    minFileSize,
    maxFileSize,
    maxFilesPerDrop,
    onDrop,
    disabled = false,
}: AppDropzoneProps): ReactElement => {
    const theme = useTheme()
    const { isTabletOrMob } = useScreenSize()

    return (
        <Box>
            <Dropzone
                onDrop={onDrop}
                maxFiles={maxFilesPerDrop}
                minSize={minFileSize}
                maxSize={maxFileSize}
            >
                {({ getRootProps, getInputProps, isDragActive }) => (
                    <div {...getRootProps()}>
                        <input {...getInputProps()} disabled={disabled} />
                        <Box
                            display="flex"
                            flexDirection="column"
                            alignItems="center"
                            borderRadius={2}
                            sx={{
                                paddingY: isTabletOrMob ? 3 : 5,
                                paddingX: isTabletOrMob ? 2 : 5,
                                border: "0.5px dashed",
                                backgroundColor:
                                    theme.palette.mode === "dark"
                                        ? theme.palette.background
                                              .contentBackground
                                        : theme.palette.grey[50],
                                borderColor: theme.palette.grey[500],
                            }}
                        >
                            <AttachmentIcon
                                sx={{
                                    width: 95,
                                    height: 95,
                                    marginBottom: 3,
                                }}
                                color="primary"
                            />

                            <Typography align="center" variant="h6">
                                {isDragActive
                                    ? "Drop Files Here"
                                    : "Drag and drop your file here to upload"}
                            </Typography>
                            <Box
                                display="flex"
                                alignItems="center"
                                my={2}
                                width="60%"
                            >
                                <Box flex="1">
                                    <Divider />
                                </Box>
                                <Box mx={4}>
                                    <Typography
                                        variant="body1"
                                        color="textSecondary"
                                    >
                                        or
                                    </Typography>
                                </Box>
                                <Box flex="1">
                                    <Divider />
                                </Box>
                            </Box>
                            <div className="centered">
                                <AppButton
                                    variant="outlined"
                                    size="large"
                                    disabled={disabled}
                                >
                                    Click to Select
                                </AppButton>
                            </div>
                        </Box>
                    </div>
                )}
            </Dropzone>
        </Box>
    )
}

AppDropzone.defaultProps = {
    disabled: false,
}

export default AppDropzone
